import angular = require('angular');
import _ = require('underscore');
import { EnumService } from '../../../app.common/modules/common/services/enum.service';
import { PopupService } from '../../../app.common/modules/common/services/popup.service';
import { CategoryListItem, ClassificationCategoryListItem } from '../../../app.retailer/modules/core';
import { ClassificationCategoriesService } from './classification-categories.service';

export interface IClassificationCategoryListItem extends ClassificationCategoryListItem {
    selected: boolean;
    hide: boolean;
    emulateLiveCategory?: boolean;
}

// tslint:disable-next-line:no-empty-interface
interface ICategoryListItem extends CategoryListItem {
}

export interface IClassificationCategoriesValidateComponent {
    selectedNoLiveCategories: string[];
}

export abstract class ClassificationCategoriesBase {
    public static $inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];

    public categories: IClassificationCategoryListItem[] = [];
    public singleSelect: boolean;
    public selectedCategories: ICategoryListItem[];
    public waiting: boolean;
    public errors: IClassificationCategoriesValidateComponent;
    public isLivel3Exist = false;
    public businessType: number;
    public subcategoryId: number;
    public isShowAll: boolean;

    protected categoriesTree: IClassificationCategoryListItem[];

    private flattenCategories: IClassificationCategoryListItem[];
    private changeCategory: (item: any) => any;
    private externalConfirm: boolean;

    protected constructor(
        protected classificationCategoriesService: ClassificationCategoriesService,
        protected popupService: PopupService,
        protected $timeout: ng.ITimeoutService,
        protected enumService: EnumService
    ) { }

    public abstract getCategoriesTree();

    public $onChanges(changes: any) {
        if (this.businessType) {
            this.adaptData();
        }
    }

    public selectedCategory = async (category: IClassificationCategoryListItem) => {
        const isSelected = category.selected;

        if (this.singleSelect) {
            const confirm = await this.confirmSelectedCategoryBrands(category);
            if (confirm) {
                const parent = category.ParentID ? _.find(this.flattenCategories, (item) => {
                    return item.ID === category.ParentID;
                }) : null;
                const flatten = parent ? this.classificationCategoriesService.flattenCategories(parent.Subcategories) as IClassificationCategoryListItem[] :
                    this.flattenCategories;

                _.forEach(flatten, (item) => {
                    item.selected = false;
                    if (this.isLiveCategory(item)) {
                        this.changeLiveCategory(item);
                    }
                });
            } else {
                return;
            }
        }

        this.updateSiblings(category, isSelected);
        if (isSelected) {

            this.selectedCategoriesToParent(category);
            if (this.isLiveCategory(category)) {
                this.changeLiveCategory(category);
            }
        } else {
            const liveChildCategories = this.getLiveCategories(category);
            const ids = _.pluck(liveChildCategories, 'ID');
            const confirm = await this.confirmSelectedCategoryBrands(category, ids);
            if (confirm) {
                this.unselectChildCategories(category);
            } else {
                return;
            }
        }
        this.validateSelectedNoLiveCategories();

        this.isLivel3Exist = this.isLevel3Exist();
    }

    public isRootSelected(): boolean {
        return _.any(this.categories, (category) => {
            return category.selected;
        });
    }

    public isCategorySelected() {
        return _.any(this.selectedCategories);
    }

    protected isLevel3Exist() {
        return _.any(this.flattenCategories, (category) => {
            return category.selected && category.Level === 2 && _.any(category.Subcategories);
        });
    }
    protected confirmSelectedCategoryBrands = async (category: IClassificationCategoryListItem, liveCategoryIDs?: number[]) => {
        if (this.externalConfirm) {
            return true;
        }
        let categoryBrands: ICategoryListItem[] = _.filter(this.selectedCategories, (categoryItem) => {
            return false; // _.any(category.Brands);
        });

        if (liveCategoryIDs) {
            categoryBrands = _.filter(categoryBrands, (categoryItem) => {
                return _.contains(liveCategoryIDs, categoryItem.CategoryID);
            });
        }

        if (categoryBrands && !_.isEmpty(categoryBrands)) {
            try {
                await this.popupService.confirm({
                    title: 'Remove category & brands',
                    content: '<p>Are you sure you want to remove this category & brands?</p>'
                });
            } catch (error) {
                category.selected = !category.selected;
                return false;
            }
        }
        return true;
    }

    protected validateSelectedNoLiveCategories = () => {
        const selected: IClassificationCategoryListItem[] = _.where(this.flattenCategories, { selected: true });
        const selectedNoLiveCategories = _.filter(selected, (category) => {
            return !this.isLiveCategory(category) && _.all(category.Subcategories, (subCategory: IClassificationCategoryListItem) => {
                return !subCategory.selected;
            });
        });

        if (!this.errors) {
            this.errors = {
                selectedNoLiveCategories: null
            };
        }
        if (selectedNoLiveCategories) {
            this.errors.selectedNoLiveCategories = _.pluck(selectedNoLiveCategories, 'Name');
        } else {
            this.errors.selectedNoLiveCategories = null;
        }
    }

    protected async adaptData() {
        this.categories = angular.copy(await this.getCategoriesTree()) as IClassificationCategoryListItem[];

        if (!this.businessType) { return console.warn('Business type is undefined'); }

        if (this.enumService.BusinessType.All === this.businessType) {
            this.isShowAll = true;
        } else {
            this.categories = _.filter(this.categories, (item) => item.Type === this.businessType);
            if (this.subcategoryId) {
                _.forEach(this.categories, (category) => {
                    category.Subcategories = _.filter(category.Subcategories, (item) => item.ID === this.subcategoryId);
                });
            }
            const root = _.first(this.categories);
            if (root) {
                root.selected = true;
            }
        }

        this.errors = {
            selectedNoLiveCategories: null
        };
        if (!this.selectedCategories) {
            this.selectedCategories = [];
        }
        /*  _.forEach(this.selectedCategories, (category) => {
             category.type = this.classificationCategoriesService.categoryType;
         }); */

        for (const level1Value of this.categories) {
            const level1ID = level1Value.ID;
            for (const level2Value of level1Value.Subcategories) {
                const level2ID = level2Value.ID;
                if (level2Value.Subcategories && level2Value.Subcategories.length > 0) {
                    for (const level3Value of level2Value.Subcategories) {
                        const level3ID = level3Value.ID;
                        level3Value.logoPurple = `/assets/images/classificationCategory/${level1ID}/purple/${level2ID}/${level3ID}.svg`;
                        level3Value.logoWhite = `/assets/images/classificationCategory/${level1ID}/white/${level2ID}/${level3ID}.svg`;
                    }
                } else {
                    level2Value.logoPurple = `/assets/images/classificationCategory/${level1ID}/purple/${level2ID}.svg`;
                    level2Value.logoWhite = `/assets/images/classificationCategory/${level1ID}/white/${level2ID}.svg`;
                }
            }
        }

        this.flattenCategories = this.classificationCategoriesService.flattenCategories(this.categories) as IClassificationCategoryListItem[];
        const addCategories = [];
        _.forEach(this.flattenCategories, (category) => {
            if (category.Level === 2 && _.isEmpty(category.Subcategories)) {
                category.emulateLiveCategory = true;
                const copy = angular.copy(category);
                copy.Level = 3;
                addCategories.push(copy);
                category.Subcategories = [copy];
            }
        });

        this.flattenCategories = this.flattenCategories.concat(addCategories);
        let parentsHide = [];
        _.forEach(this.flattenCategories, (category) => {
            category.hide = false;
            if (category.ParentID) {
                parentsHide.push(category.ParentID);
            }
        });
        parentsHide = _.uniq(parentsHide);
        _.forEach(parentsHide, (id) => {
            const parentCategory = _.findWhere(this.flattenCategories, { ID: id });
            if (parentCategory) {
                parentCategory.hide = _.all(parentCategory.Subcategories, (subcategory: IClassificationCategoryListItem) => {
                    return subcategory.hide;
                });
            }
        });
        this.$timeout();
        this.setSelectedClassificationCategories();
        this.isLivel3Exist = this.isLevel3Exist();
    }

    protected setSelectedClassificationCategories() {
        const selectedCategoryIDs = _.pluck(this.selectedCategories, 'CategoryID');

        if (selectedCategoryIDs.length === 0) {
            const selectedCategory = _.filter(this.flattenCategories, (category) => {
                return category.ID == null;
            });
            _.forEach(selectedCategory, this.selectedCategoriesToParent);
        } else {
            const selectedCategory = _.filter(this.flattenCategories, (category) => {
                return _.contains(selectedCategoryIDs, category.ID);
            });
            _.forEach(selectedCategory, this.selectedCategoriesToParent);
            _.forEach(selectedCategory, (category) => {
                this.updateSiblings(category, true);
            });
        }
    }

    protected selectedCategoriesToParent = (category: IClassificationCategoryListItem) => {
        category.selected = true;
        if (category.ParentID) {
            while (category && category.ParentID) {
                category = _.findWhere(this.flattenCategories, { ID: category.ParentID });
                if (!_.isUndefined(category)) {
                    category.selected = true;
                }
            }
        }
    }

    protected getUrlFromName = (category: IClassificationCategoryListItem): { purple: string; white: string } => {
        const split = category.FullName.split(' > ');
        for (let c = 0; c < _.size(split); c++) {
            split[c] = split[c].replace(/[\'\\\/\,\(\)]/g, '')
              .replace(/&/g, 'and')
              .replace(/\s{1,2}/g, '-')
              .replace(/’/g, '').toLowerCase();
        }

        const purpleSplit = split.slice();
        const whiteSplit = split.slice();
        purpleSplit.splice(1, 0, 'purple');
        whiteSplit.splice(1, 0, 'white');

        return {
            purple: purpleSplit.join('/') + '.svg',
            white: whiteSplit.join('/') + '.svg'
        };
    }

    protected changeLiveCategory(category: IClassificationCategoryListItem) {
        let changeModel = category.selected;
        if (category.selected) {
            if (this.singleSelect) {
                this.selectedCategories.splice(0, this.selectedCategories.length);
            }
            this.selectedCategories.push({
                CategoryID: category.ID,
                CategoryFullName: category.FullName,
                ParentID: category.ParentID
            });
        } else {
            this.selectedCategories = _.reject(this.selectedCategories, (item) => {
                const equal = item.CategoryID === category.ID;
                if (equal) { changeModel = true; }
                return equal;
            });
        }

        if (changeModel) {
            this.$timeout(() => this.changeCategory({item: category}));
        }
    }

    protected unselectChildCategories(category: IClassificationCategoryListItem) {
        category.selected = false;

        if (this.isLiveCategory(category)) {
            this.changeLiveCategory(category);
        }
        _.forEach(category.Subcategories, (subcategory: IClassificationCategoryListItem) => {
            subcategory.selected = false;
            if (this.isLiveCategory(category)) {
                this.changeLiveCategory(subcategory);
            } else {
                this.unselectChildCategories(subcategory);
            }
        });
    }

    protected getLiveCategories(category: IClassificationCategoryListItem): IClassificationCategoryListItem[] {

        let result: IClassificationCategoryListItem[] = [];
        if (category.Subcategories! || _.isEmpty(category.Subcategories)) {
            result = [category];
        }
        if (category.Subcategories) {
            _.forEach(category.Subcategories as IClassificationCategoryListItem[], (subcategory) => {
                result = result.concat(this.getLiveCategories(subcategory));
            });
        }
        return result;
    }

    protected isLiveCategory(category: IClassificationCategoryListItem) {
        return category.emulateLiveCategory || !category.Subcategories || _.isEmpty(category.Subcategories);
    }

    private updateSiblings(category: IClassificationCategoryListItem, isSelected: boolean) {
        if (category.emulateLiveCategory) {

            const siblings = _.where(this.flattenCategories, { ID: category.ID }) as IClassificationCategoryListItem[];
            _.forEach(siblings, (item) => { item.selected = isSelected; });
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/categories/classification-categories-base.component.ts